import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my ideal body!",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'I have been working out for 2 years now and I have never been this fit and healthy! Thank you Fitclub!',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Losing weight has never been this easy! I am so happy with the results and I am so grateful to Fitclub!',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
